export default __webpack_public_path__ + "static/media/yulia.c7b261da.JPG";